import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Header from "./Header";
import Sidebar from "./Sidebar";
import ProjectDetails from "./ProjectDetails";
import FinancialPerformance from "./FinancialPerformance";
import Scheduling from "./Scheduling";
import ProductionPerformance from "./ProductionPerformance";
import TeamsChat from "./TeamsChat";
import ProjectEmails from "./ProjectEmails";
import ProjectTeam from "./ProjectTeam";
import ScopeDescription from "./ScopeDescription";
import { Contacts } from "./contacts/Contacts";
import { ManageContacts } from "./contacts/ManageContacts";
import { ManageProject } from './projects/ManageProject';
import "./ProjectDashboard.css";

function ProjectDashboard() {
  const location = useLocation();
  const navigate = useNavigate();
  const isContactsPage = location.pathname.includes('/contacts');
  const [isProjectSelected, setIsProjectSelected] = useState(() => 
    localStorage.getItem('isProjectSelected') === 'true'
  );

  const [projectData, setProjectData] = useState(() => {
    const savedDetails = localStorage.getItem('selectedProjectDetails');
    return savedDetails ? JSON.parse(savedDetails) : {};
  });

  const [performanceMetrics, setPerformanceMetrics] = useState({
    billingProgress: 53.7,
    costPerformance: 53.7,
  });

  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);

  function toggleSidebar() {
    setIsSidebarCollapsed(!isSidebarCollapsed);
  }

  useEffect(() => {
    const handleProjectDetailsChange = (event) => {
      setProjectData(event.detail);
      setIsProjectSelected(true);
    };

    const handleProjectDataCleared = () => {
      setProjectData(null);
      setIsProjectSelected(false);
    };

    window.addEventListener('projectDetailsChanged', handleProjectDetailsChange);
    window.addEventListener('projectDataCleared', handleProjectDataCleared);

    return () => {
      window.removeEventListener('projectDetailsChanged', handleProjectDetailsChange);
      window.removeEventListener('projectDataCleared', handleProjectDataCleared);
    };
  }, []);

  useEffect(() => {
    // If trying to access dashboard without selected project, redirect to home
    if (location.pathname === '/dashboard' && !isProjectSelected) {
      navigate('/');
    }
  }, [location.pathname, isProjectSelected, navigate]);

  return (
    <div className="page-scale">
      <div className="project-dashboard">
        <Header />
        <main className="dashboard-main">
        <div className="sidebar-container">
        <Sidebar isCollapsed={isSidebarCollapsed} projectData={projectData} />
          </div>
          <div className="dashboard-content">
            {isContactsPage ? (
              <div className="flex flex-col px-9 pt-4 pb-9 mx-auto w-full rounded-xl bg-stone-50 max-md:px-5 max-md:mt-7 max-md:max-w-full">
                {location.pathname === '/contacts/manage' ? (
                  <ManageContacts />
                ) : (
                  <Contacts />
                )}
              </div>
            ) : location.pathname === '/' ? (
              <ManageProject />
            ) : isProjectSelected && projectData ? (
              <>
              <div className="sticky-project-details">
                  <ProjectDetails projectData={projectData} />
                </div>
                <div className="scrollable-content">
                <ScopeDescription scopeDescription={projectData.scopeDescription}/>
                <FinancialPerformance projectData={projectData} />
                <Scheduling projectData={projectData} />
                <ProductionPerformance />
                <section className="communication-section">
                  <TeamsChat projectData={projectData} />
                  <ProjectEmails projectData={projectData} />
                </section>
                <div className="mt-8">
                  <Contacts />
                </div>
              </div>
              </>
            ) : null}
          </div>
        </main>
      </div>
    </div>
  );
}

export default ProjectDashboard;